// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oa-0";
export var discountCodeInput = "_oa-1";